import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";
import { formatPrintDate } from "../formatPrintDate";

const PrintSection6 = ({ section6 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 6 – Business Conduct
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Non-disclosure of relevant information may result in your application
        being declined.
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        If you answer Yes to any of these questions, please provide full details
        in the text box.
      </Text>
      <Text style={PrintApplicationStyles.inputLabel}>6.1 General</Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Have you ever been dismissed or asked to leave by any employer
              or network of life Assurance company?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.dismissed === true
                  ? "Yes"
                  : section6?.dismissed === false
                    ? "No"
                    : section6?.dismissed === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Have you ever received any warnings, written or verbal?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.receivedWarnings === true
                  ? "Yes"
                  : section6?.receivedWarnings === false
                    ? "No"
                    : section6?.receivedWarnings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) Have you ever had an investigation or review carried out on you
              or the business conducted by you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.investigationOrReview === true
                  ? "Yes"
                  : section6?.investigationOrReview === false
                    ? "No"
                    : section6?.investigationOrReview === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              d) Have you ever undertaken or been asked to undertake any
              additional training, including increased supervision, under any
              Training and Competence Scheme?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.additionalTraining === true
                  ? "Yes"
                  : section6?.additionalTraining === false
                    ? "No"
                    : section6?.additionalTraining === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              e) Have you ever been assessed by the FCA or any authorised firm
              or regulatory body?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.assessedByFCA === true
                  ? "Yes"
                  : section6?.assessedByFCA === false
                    ? "No"
                    : section6?.assessedByFCA === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              f) If you have been assessed please provide a copy of your
              assessment report? and RMAR (if applicable)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.assessmentReport === true
                  ? "Yes"
                  : section6?.assessmentReport === false
                    ? "No"
                    : section6?.assessmentReport === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              g) Have you ever been removed from a Lenders panel or had an
              agency refused or terminated by a Product Provider?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.removedFromLendersPanel === true
                  ? "Yes"
                  : section6?.removedFromLendersPanel === false
                    ? "No"
                    : section6?.removedFromLendersPanel === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              h) Have you ever acted in a Directly Authorised capacity?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.actedInDirectlyAuthorisedCapacity === true
                  ? "Yes"
                  : section6?.actedInDirectlyAuthorisedCapacity === false
                    ? "No"
                    : section6?.actedInDirectlyAuthorisedCapacity === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              i) If yes, please provide a copy of your latest RMAR. Is this
              enclosed?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.latestRMAR === true
                  ? "Yes"
                  : section6?.latestRMAR === false
                    ? "No"
                    : section6?.latestRMAR === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              j) Have you ever been subject to any remedial or corrective action
              in relation to Treating Customers Fairly or Consumer Duty?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.treatedCustomersFairly === true
                  ? "Yes"
                  : section6?.treatedCustomersFairly === false
                    ? "No"
                    : section6?.treatedCustomersFairly === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              k) Have you ever been involved in the promotion, advice or selling
              of Arch Cru, British Steel, Key Data or high risk products?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.highRiskProducts === true
                  ? "Yes"
                  : section6?.highRiskProducts === false
                    ? "No"
                    : section6?.highRiskProducts === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              l) Have you ever had any complaints against you whether upheld or
              not? If yes please complete section 6.2 below.
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.complaint === true
                  ? "Yes"
                  : section6?.complaint === false
                    ? "No"
                    : section6?.complaint === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              m) Have you ever been the subject of a breach in relation to
              activities regulated by the Financial Conduct Authority.
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.subjectOfBreach === true
                  ? "Yes"
                  : section6?.subjectOfBreach === false
                    ? "No"
                    : section6?.subjectOfBreach === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              n) Have you ever applied to Rosemount prior to this application?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.appliedToRosemount === true
                  ? "Yes"
                  : section6?.appliedToRosemount === false
                    ? "No"
                    : section6?.appliedToRosemount === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              o) Have you ever advised on Defined Benefit (DB) pension
              transfers?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.advisedOnDBPensionTransfers === true
                  ? "Yes"
                  : section6?.advisedOnDBPensionTransfers === false
                    ? "No"
                    : section6?.advisedOnDBPensionTransfers === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Please provide us further information, including number of cases &
              whether you have had any complaints in relation to the DB
              business.
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.additionalInformationDBPensionTransfers || ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              p) Have you ever referred a client to another firm or adviser in
              relation to a Defined Benefit (DB) pension transfers?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.referredClientToAnotherFirm === true
                  ? "Yes"
                  : section6?.referredClientToAnotherFirm === false
                    ? "No"
                    : section6?.referredClientToAnotherFirm === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>

          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Please provide us further information, including number of cases &
              who you referred them to.
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.additionalInformationReferredClientToAnotherFirm ||
                  ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              q) Have you ever advised on, or referred business that resulted
              in, a client investing in an unregulated investment?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.advisedOnUnregulatedInvestment === true
                  ? "Yes"
                  : section6?.advisedOnUnregulatedInvestment === false
                    ? "No"
                    : section6?.advisedOnUnregulatedInvestment === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>

          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Additional Information (6.1)
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section6?.additionalInformationS6_1 || ""}</Text>
            </View>
          </View>
        </View>
      </View>
      <Text style={PrintApplicationStyles.inputLabel}>6.2 Complaints</Text>
      <Text style={PrintApplicationStyles.inputLabel}>
        Please provide full details regarding any complaints against you whether
        upheld or not.
      </Text>
      <View style={PrintApplicationStyles.table}>
        <View style={PrintApplicationStyles.tableRow}>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Customer Name
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Date
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Nature of the complaint
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Outcome/Settlement
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Redress compensation amount
          </Text>
        </View>
        {section6?.complaints && Object.keys(section6.complaints).length > 0
          ? Object.values(section6.complaints).map((complaint, index) => (
              <View style={PrintApplicationStyles.tableRow} key={index}>
                <Text style={PrintApplicationStyles.tableCell}>
                  {complaint.customer || ""}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {formatPrintDate(complaint?.complaintDate)}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {complaint.natureOfComplaint || ""}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {complaint.outcome || ""}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {complaint.redressCompensationAmount || ""}
                </Text>
              </View>
            ))
          : null}
      </View>

      <Text style={PrintApplicationStyles.inputLabel}>
        6.3 Other Information
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Do you have any trading names?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.tradingNames === true
                  ? "Yes"
                  : section6?.tradingNames === false
                    ? "No"
                    : section6?.tradingNames === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              If yes, please give full name (s)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section6?.tradingName || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Are you a shareholder in any other financial services company
              where your shareholding exceeds 10% of total shares issued?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.shareholder === true
                  ? "Yes"
                  : section6?.shareholder === false
                    ? "No"
                    : section6?.shareholder === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) Have you ever held, or do you currently hold, any contracts
              with any financial services company which are not listed in the
              employment section of the application?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.currentContracts === true
                  ? "Yes"
                  : section6?.currentContracts === false
                    ? "No"
                    : section6?.currentContracts === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              d) Have you ever been a director of a financial services company?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.directorOfFinancialServicesCompany === true
                  ? "Yes"
                  : section6?.directorOfFinancialServicesCompany === false
                    ? "No"
                    : section6?.directorOfFinancialServicesCompany === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              e) Do you have any outstanding debts with any Financial Services
              Company? If yes, please enter full details below
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section6?.outstandingDebts === true
                  ? "Yes"
                  : section6?.outstandingDebts === false
                    ? "No"
                    : section6?.outstandingDebts === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Current DPL</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section6?.currentDPL || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              If yes, please provide a copy or reference number
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section6?.referenceNumber || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Additional Information (6.3)
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section6?.additionalInformationS6_3 || ""}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text style={PrintApplicationStyles.inputLabel}>
        6.3.1 Director of Financial Services Company
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Please provide details of the financial services companies where you are
        a director.
      </Text>
      <View style={PrintApplicationStyles.table}>
        <View style={PrintApplicationStyles.tableRow}>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Company Name
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Business Relationship
          </Text>
        </View>
        {section6?.director && Object.keys(section6.director).length > 0
          ? Object.values(section6.director).map((director, index) => (
              <View style={PrintApplicationStyles.tableRow} key={index}>
                <Text style={PrintApplicationStyles.tableCell}>
                  {director.companyName || ""}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {director.businessRelationship || ""}
                </Text>
              </View>
            ))
          : null}
      </View>

      <Text style={PrintApplicationStyles.inputLabel}>
        6.3.2 Outstanding Debts
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Please provide details of any outstanding debts.
      </Text>
      <View style={PrintApplicationStyles.table}>
        <View style={PrintApplicationStyles.tableRow}>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Company
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Amount of Debt
          </Text>
          <Text
            style={[
              PrintApplicationStyles.tableCell,
              PrintApplicationStyles.tableHeader,
            ]}
          >
            Details of Arrangements
          </Text>
        </View>
        {section6?.debtDetails && Object.keys(section6.debtDetails).length > 0
          ? Object.values(section6.debtDetails).map((debt, index) => (
              <View style={PrintApplicationStyles.tableRow} key={index}>
                <Text style={PrintApplicationStyles.tableCell}>
                  {debt.company || ""}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {debt.amountOfDebt || ""}
                </Text>
                <Text style={PrintApplicationStyles.tableCell}>
                  {debt.detailsOfArrangements || ""}
                </Text>
              </View>
            ))
          : null}
      </View>
    </>
  );
};

export default PrintSection6;